// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn_djge9","reset":"reset_3e876"};